export default __webpack_public_path__ + "static/profile-pic-4-8cfb9e47d9939bbe474323805b290a65.jpeg";